import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-tr-menu',
  templateUrl: './tr-menu.component.html',
  styleUrls: ['./tr-menu.component.css']
})
export class TrMenuComponent implements OnInit {
    labourNo;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
    }

    private async loadMenu() {
        if (!!this.labourNo) {
            this.menu = (await this.datatask.Post(122, { labour_no: this.labourNo }))[0];
        }
    }

    public async goToFunc(state: any) {
        if (!this.menu) return;

        switch (state) {
            case 'custactCalcPickSelect':
                const response = (await this.datatask.Post(875, {
                    p2_pofinish_keyno: this.menu.p2_pofinish_keyno,
                    custact_no: this.menu.custactcalc_custact_no
                }))[0];

                this.stateService?.go(response?.webpagename, response?.parms);
                break;
            case 'trNewJob':
                if (this.menu.custactcalc_custact_no !== '0') {
                    this.stateService?.go('custactcalcjobexit', {
                        labour_no: this.menu.labour_no,
                        custactcalc_custact_no: this.menu.custactcalc_custact_no,
                        function_name: 'SWITCH'
                    });
                } else {
                    this.stateService?.go('trnewjob', { labour_no: this.menu.labour_no });
                }
                break;
            case 'trNewJobConf':
                if (this.menu.custactcalc_custact_no !== '0') {
                    this.stateService?.go('custactcalcjobexit', {
                        labour_no: this.menu.labour_no,
                        custactcalc_custact_no: this.menu.custactcalc_custact_no,
                        function_name: 'EXIT'
                    });
                } else {
                    this.stateService?.go('trnewjobconf', {
                        labour_no: this.menu.labour_no,
                        argtype: 'exit',
                        argvalue: '0'
                    });
                }
                break;
            case 'trstart':
                this.stateService?.go('trstart');
                break;
            case 'pofinishprodlist':
                this.stateService?.go('pofinishprodlist', { p2_pofinish_keyno: this.menu.p2_pofinish_keyno });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    labour_name: string;
    shift_name: string;
    powtimestamp_start: string;
    job_note: string;
    p2_pofinish_info: string;
    operation_name: string;
    equipment_name: string;
    custact_name: string;
    p2_pofinish_keyno: string;
    custact_no: string;
    show_button_po_add: string;
    custactcalc_custact_no: string;
    show_button_pictures: string;
    show_button_documents: string;
    documents_parms: string;
    nbr_of_p2_pofinishprod: string;
    labour_no: string;
    todaydate: string;
    stamped: string;
    show_pofinish_button: string;
    equipment_id: string;
    operation_id: string;
}
